import { render, staticRenderFns } from "./tableEmpty.vue?vue&type=template&id=c84df946&scoped=true&"
import script from "./tableEmpty.vue?vue&type=script&lang=ts&"
export * from "./tableEmpty.vue?vue&type=script&lang=ts&"
import style0 from "./tableEmpty.vue?vue&type=style&index=0&id=c84df946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84df946",
  null
  
)

export default component.exports